import { PROVIDER_SOURCE } from '../../constants/quote';
export var useQuoteInsuranceInfo = function useQuoteInsuranceInfo() {
  var getInsuranceNameUniversalText = function getInsuranceNameUniversalText(data) {
    var name = 'Business insurance';

    switch (data === null || data === void 0 ? void 0 : data.providerCode) {
      case PROVIDER_SOURCE().GREATEAMERICAN.value:
        name = 'Motor Truck Cargo insurance';
        break;

      default:
        break;
    }

    return name;
  };

  return {
    getInsuranceNameUniversalText: getInsuranceNameUniversalText
  };
};